const styles = theme => ({
  chart: {
    width: "100%"
  },
  cardContent: {
    padding: "0px !important"
  },
  cardActions: {
    padding: "4px 4px",
    height: "auto"
  },
  cardActionsTitle: {
    background: "#005795 !important",
    padding: "5px",
    textAlign: "center"
  },
  title: {
    color: "#FFFFFF"
  },
  cardActionsNav: {
    padding: "5px",
    textAlign: "center",
    color: "white",
    "& h2": {
      color: "white",
      fontWeight: "500",
      fontSize: "1rem",
      lineHeight: "32px"
    },
    "& span": {
      color: "white"
    }
  },
  cardActionsNavPassed: {
    background: `${theme.palette.success} !important`
  },
  cardActionsNavFailed: {
    background: `${theme.palette.fail} !important`
  },
  cardActionsNavNotRun: {
    background: "grey !important"
  },
  borderpassed: {
    border: `2px solid ${theme.palette.success}`
  },
  borderfailed: {
    border: `2px solid ${theme.palette.fail}`
  },
  bordernotrun: {
    border: "2px solid grey"
  },
  nav: {
    padding: "initial",
    minWidth: "initial",
    minHeight: "initial",
    width: "100%",
    height: "100%"
  },
  cardCover: {
    height: "270px",
    width: "295px"
  },
  content: {
    height: "230px"
  },
  thumbnailNav: {
    height: "40px"
  },
  thumb: {
    minWidth: "25%"
  }
});

export default styles;



// WEBPACK FOOTER //
// ./src/components/common/results/thumbnails/styles.js